/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class DeleteGraphService extends BaseService {
  constructor() {
    super(constants.DELETE_GRAPH, 'deleteGraphStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId, version, comment } = payload;

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').post(
        `/graphs/${graphId}/delete?version=${version}`,
        { comment },
        { headers: enhancedHeaders }
      );
    }
    return this.getClient('aiadmin').post(`/graphs/${graphId}/delete?version=${version}`, { comment }, { headers });
  }

  handleResponse() {
    const notification = {
      open: true,
      type: 'success',
      message: 'Graph deleted successfully!'
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
    Framework.getEventManager().publish(constants.DELETE_GRAPH_SUCCESS);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      const notification = {
        open: true,
        message: 'Failed to delete. Please try again.',
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: 'Request timeout. Please try again.',
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getEventManager().publish(constants.DELETE_GRAPH_ERROR);
  }
}
